import React from "react";
import PropTypes from "prop-types";
import { Spinner, Button } from "reactstrap";

/**
 * LoadingButton
 * Botão com estado de carregamento integrado usando Reactstrap Button.
 */
const LoadingButton = ({
    loading = false,
    loadingText = "Carregando...",
    children,
    disabled,
    ...props
}) => {
    return (
        <Button
            disabled={loading || disabled}
            {...props}
        >
            {loading ? (
                <span className="d-flex align-items-center justify-content-center">
                    <Spinner size="sm" className="me-2" />
                    {loadingText}
                </span>
            ) : (
                children
            )}
        </Button>
    );
};

LoadingButton.propTypes = {
    loading: PropTypes.bool,
    loadingText: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    className: PropTypes.string
};

export default LoadingButton;
